<template>
  <PageTerms v-bind="{ terms }" />
</template>

<script setup lang="ts">
import enStrings from "~/locales/en.json";

const nuxtApp = useNuxtApp();
const translate = nuxtApp.$i18n.global.t;

const terms = {
  name: translate("site.terms.content.title"),
  lastUpdated: "10th June 2024",
  content: [] as any,
};

let i = 1;
while (`heading${i}` in enStrings.site.terms.content) {
  terms.content.push({
    heading: translate(`site.terms.content.heading${i}`),
    clauses: [],
  });

  let j = 1;
  while (`clause${i}-${j}` in enStrings.site.terms.content) {
    if (`subclause${i}-${j}-1` in enStrings.site.terms.content) {
      terms.content[i - 1].clauses.push({
        subheading: translate(`site.terms.content.clause${i}-${j}`),
        subclauses: [],
      });

      let k = 1;
      while (`subclause${i}-${j}-${k}` in enStrings.site.terms.content) {
        terms.content[i - 1].clauses[j - 1].subclauses.push(
          translate(`site.terms.content.subclause${i}-${j}-${k}`),
        );
        k++;
      }
    } else {
      terms.content[i - 1].clauses.push(
        translate(`site.terms.content.clause${i}-${j}`),
      );
    }

    j++;
  }

  i++;
}

const config = useRuntimeConfig();
const title = ref("Content Policy");
const canonical = ref(`${config.public.baseUrl}/en/terms/content`);
definePageMeta({ title: "Content Policy" });

useHead({
  title: title,
  link: [{ rel: "canonical", href: canonical }],
  meta: [
    {
      property: "og:title",
      content: `${title.value} - ${config.public.siteName}`,
    },
  ],
});
</script>
